import { Level1MenuItem } from "@/features";
import { MdCurrencyExchange } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsEnergyContractReadonly } from "@/utils";
import { RootState, useAppSelector } from "@/app/store";

const parentPath = "energy-contract";

export const EnergyContractsMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const hasCompanies = useAppSelector(
    (state: RootState) => state?.auth?.user?.hasCompanies,
  );

  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Contracts")}
      icon={<MdCurrencyExchange size={18} className="mx-3" />}
      codes={permissionsEnergyContractReadonly}
      feature="energy-contract"
      hide={!hasCompanies}
    />
  );
};
